// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-field-container {
  display: grid;
  align-items: center;
  grid-template-columns: 200px 1fr;
  padding: 12px 0;
  font-size: 14px;
}
.edit-field-container .edit-field-holder {
  display: flex;
}
.edit-field-container .edit-field-edit-icon {
  width: 20px;
  cursor: pointer;
}
.edit-field-container .edit-field-title {
  color: #142A31;
  font-weight: 500;
}

.edit-field-styles {
  width: 90%;
  box-sizing: border-box;
  outline: none;
  height: 34px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid #D3E1ED;
  padding: 0 12px;
}

.date-field-styles {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #D3E1ED;
  outline: none;
  height: 34px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0 12px;
}

.calendar-field-styles {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #D3E1ED;
  outline: none;
  height: 34px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  padding: 0 12px;
}

.edit-field-styles-readonly {
  width: 90%;
  box-sizing: border-box;
  border: 0;
  outline: none;
  height: 36px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #6A8991;
}`, "",{"version":3,"sources":["webpack://./src/components/EditFieldGroup/EditField/EditField.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;AACD;AACC;EACC,aAAA;AACF;AAGC;EACC,WAAA;EACA,eAAA;AADF;AAIC;EACC,cAAA;EACA,gBAAA;AAFF;;AAMA;EACC,UAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAHD;;AAMA;EACC,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAHD;;AAMA;EACC,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,eAAA;AAHD;;AAMA;EACC,UAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAHD","sourcesContent":[".edit-field-container {\n\tdisplay: grid;\n\talign-items: center;\n\tgrid-template-columns: 200px 1fr;\n\tpadding: 12px 0;\n\tfont-size: 14px;\n\n\t.edit-field-holder {\n\t\tdisplay: flex;\n\t\t//justify-content: flex-end;\n\t}\n\n\t.edit-field-edit-icon {\n\t\twidth: 20px;\n\t\tcursor: pointer;\n\t}\n\n\t.edit-field-title {\n\t\tcolor: #142A31;\n\t\tfont-weight: 500;\n\t}\n}\n\n.edit-field-styles {\n\twidth: 90%;\n\tbox-sizing: border-box;\n\toutline: none;\n\theight: 34px;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tborder: 1px solid #D3E1ED;\n\tpadding: 0 12px;\n}\n\n.date-field-styles {\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tborder: 1px solid #D3E1ED;\n\toutline: none;\n\theight: 34px;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 12px;\n}\n\n.calendar-field-styles {\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tborder: 1px solid #D3E1ED;\n\toutline: none;\n\theight: 34px;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tuser-select: none;\n\tcursor: pointer;\n\tpadding: 0 12px;\n}\n\n.edit-field-styles-readonly {\n\twidth: 90%;\n\tbox-sizing: border-box;\n\tborder: 0;\n\toutline: none;\n\theight: 36px;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-weight: 700;\n\tcolor: #6A8991;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
